"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getTagsFromSchema = _interopRequireDefault(require("./getTagsFromSchema"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var schemas = {
  player: _constants.TWITTER_PLAYER_CARD_SCHEMA,
  app: _constants.TWITTER_APP_CARD_SCHEMA,
  summary: _constants.TWITTER_SUMMARY_CARD_SCHEMA,
  summary_large_image: _constants.TWITTER_SUMMARY_CARD_SCHEMA
};

var getTwitterCardTags = function getTwitterCardTags(tags) {
  if (tags.card === 'summary_with_large_image') {
    // eslint-disable-next-line no-console
    console.warn('summary_with_large_image is deprecated and will be removed in the next major release. Please use summary_large_image instead. See https://github.com/americanexpress/react-seo/issues/24 for more information');
    return (0, _getTagsFromSchema.default)(schemas.summary_large_image, _objectSpread(_objectSpread({}, tags), {}, {
      card: 'summary_large_image'
    }));
  }

  if (schemas[tags.card]) {
    return (0, _getTagsFromSchema.default)(schemas[tags.card], tags);
  }

  throw new Error("Unsupported Twitter Card type: ".concat(tags.card));
};

var _default = getTwitterCardTags;
exports.default = _default;